import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function FoodIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9535 7.6C30.5312 7.6 31 8.0704 31 8.65C31 9.2296 30.5312 9.7 29.9535 9.7H11.8142C11.2365 9.7 10.7677 9.2296 10.7677 8.65C10.7677 8.0704 11.2365 7.6 11.8142 7.6H29.9535Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9094 8.8558C21.7964 9.4242 21.2452 9.7938 20.6787 9.679C20.1122 9.5656 19.7439 9.0126 19.8583 8.4442L20.9745 2.8442C21.0722 2.3528 21.5006 2 22.0001 2H26.1861C26.7638 2 27.2326 2.4704 27.2326 3.05C27.2326 3.6296 26.7638 4.1 26.1861 4.1H22.8582L21.9094 8.8558Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.109 26.4048L18.4113 29.2048C18.2941 29.6724 17.8755 30 17.3955 30H2.74455C2.26456 30 1.84596 29.6724 1.72875 29.2048L1.03108 26.4048C0.952945 26.0912 1.02411 25.758 1.22224 25.5032C1.42038 25.2484 1.72456 25.1 2.04688 25.1H18.0932C18.4155 25.1 18.7197 25.2484 18.9178 25.5032C19.116 25.758 19.1871 26.0912 19.109 26.4048Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.49889 19.9676C8.81982 20.4492 8.68866 21.1016 8.20867 21.4236C7.72867 21.7456 7.07845 21.614 6.75752 21.1324L2.57153 14.8324C2.2506 14.3508 2.38176 13.6984 2.86176 13.3764C3.34175 13.0544 3.99198 13.186 4.3129 13.6676L8.49889 19.9676Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.7599 23.7C2.75013 23.5852 2.74455 23.4676 2.74455 23.35C2.74455 21.2248 4.4636 19.5 6.58171 19.5C8.69982 19.5 10.4189 21.2248 10.4189 23.35C10.4189 23.4676 10.4133 23.5852 10.4035 23.7H2.7599Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.73655 23.7C9.72679 23.5852 9.72121 23.4676 9.72121 23.35C9.72121 21.2248 11.4403 19.5 13.5584 19.5C15.6765 19.5 17.3955 21.2248 17.3955 23.35C17.3955 23.4676 17.3899 23.5852 17.3802 23.7H9.73655Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.09101 15.3252C7.79425 14.4558 8.86866 13.9 10.07 13.9C12.1881 13.9 13.9072 15.6248 13.9072 17.75C13.9072 17.8718 13.9016 17.9922 13.8905 18.1098C13.7802 18.1042 13.67 18.1 13.5584 18.1C12.2188 18.1 10.9965 18.6068 10.07 19.4384C9.90678 19.2914 9.73376 19.1542 9.55237 19.0282L7.09101 15.3252Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.3577 11.1L27.6359 27.802C27.5075 29.0508 26.4582 30 25.2066 30H19.6015C19.6699 29.8558 19.7243 29.7032 19.7648 29.5436L20.4625 26.7436C20.6439 26.0128 20.4806 25.2372 20.0174 24.6422C19.6978 24.232 19.2597 23.938 18.7727 23.7966C18.7839 23.6496 18.7909 23.4998 18.7909 23.35C18.7909 21.0512 17.316 19.0968 15.2649 18.3856C15.29 18.177 15.3025 17.9656 15.3025 17.75C15.3025 15.783 14.2211 14.0666 12.6235 13.1678L12.41 11.1H29.3577Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
